import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

/**
 * Schedule Review Modal - Select date and review type
 */
export default function ScheduleReviewModal({ staff, onClose, onSchedule }) {
  const [scheduledDate, setScheduledDate] = useState('');
  const [reviewType, setReviewType] = useState('quarterly');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!scheduledDate) {
      toast.error('Please select a date');
      return;
    }
    onSchedule(staff.staff_id, scheduledDate, reviewType);
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
          <h3 className="text-xl font-bold text-gray-900 dark:text-white">Schedule Review</h3>
          <p className="text-gray-600 dark:text-gray-400 mt-1">for {staff.name}</p>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Review Date
            </label>
            <Input
              type="date"
              value={scheduledDate}
              onChange={(e) => setScheduledDate(e.target.value)}
              min={new Date().toISOString().split('T')[0]}
              className="w-full"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Review Type
            </label>
            <select
              value={reviewType}
              onChange={(e) => setReviewType(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            >
              <option value="probation">Probation Review</option>
              <option value="quarterly">Quarterly Review</option>
              <option value="annual">Annual Review</option>
              <option value="improvement">Performance Improvement</option>
            </select>
          </div>
          
          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" onClick={onClose} className="flex-1">
              Cancel
            </Button>
            <Button type="submit" className="flex-1 bg-teal-600 hover:bg-teal-700 text-white">
              Schedule Review
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
